import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
	width: 100%;
	height: 100%;
	background-size: cover;
	background-position: center;
	padding: 84px 30px 0;
	transition: opacity 0.3s ease;

	&.apps-enter {
		opacity: 0;
	}

	&.apps-enter-active,
	&.apps-enter-done,
	&.apps-exit {
		opacity: 1;
	}

	&.apps-exit-active {
		opacity: 0;
	}
`;

const StyledAppsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	grid-auto-rows: 89px;
	grid-auto-columns: 65px;
	justify-content: space-between;
	row-gap: 16px;
	column-gap: 20px;
`;

const StyledApp = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	width: 65px;
	height: 89px;
	cursor: pointer;

	img {
		width: 65px;
		height: 65px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 500;
		font-size: 12px;
		color: #ffffff;
	}
`;

const StyledNotificationCount = styled.div`
	position: absolute;
	top: -8px;
	right: -8px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: auto;
	min-width: 20px;
	height: 20px;
	border-radius: 20px;
	background-color: #e00000;
	padding: 0 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		line-height: 14px;
		color: #ffffff;
	}
`;

export {
	StyledApp,
	StyledAppsContainer,
	StyledContainer,
	StyledNotificationCount,
};
